import banner from './Advocacia_banner.png';
import styled from 'styled-components';

export const BannerContainer = styled.div`
  height: 650px;
  width: 100%;
  //background-image: url(${banner});
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${props => props.theme.cores.primaria};
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 85%);

  @media (max-width: 768px) {
    width: 100%;
    height: 930px;
    margin-top: 50px;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${props => props.theme.cores.primaria};
  display: block;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 85%);
  }

  
`;

export const BannerContainerMobile = styled.div`
 width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${props => props.theme.cores.primaria};
  display: block;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 85%);

  
`;

export const boxStyles = {
  width: '100%',
  maxWidth: 550,
  color: '#ffffff',
 
  
  // Outros estilos aqui...

  '@media (max-width: 360px)': {
    marginTop: '90px',
    // Outros estilos para telas menores que 768px aqui...
  },
};